import api from "../../index" // make sure this is your RTK Query base API

const wealthPartnerInvoicesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAllInvoices: build.query({
      query: () => ({
        url: `/wealthPartner/invoices/admin`, // matches your new backend route
        method: "GET",
      }),
    }),
    getInvoicesWp: build.query({
      query: (params) => ({
        url: `/wealthPartner/invoices`,
        method: "GET",
        params, // optional query params if needed
      }),
    }),
    createInvoice: build.mutation({
      query: (body) => ({
        url: `/wealthPartner/invoices`,
        method: "POST",
        body,
      }),
    }),
  }),
})

export const {
  useLazyGetInvoicesWpQuery, // for manual triggering
  useLazyGetAllInvoicesQuery,
  useCreateInvoiceMutation, // mutation hook for POST
} = wealthPartnerInvoicesApi
